import React from 'react';
import './icon.scss';
import { IconProps } from '../../types/icons';

const MeetingPointIcon: React.FC<IconProps> = ({
  fill,
  color,
  width = 24,
  height,
  onClick,
  className = '',
}) => {
  const classBase = 'custom-icon';
  const classes = `${classBase} ${classBase}-color-${color} ${className} `;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height || width}
      className={classes}
      fill={fill || '#7E8A96'}
      onClick={onClick}
      data-testid="meeting-point-icon"
      viewBox="0 0 24 24"
    >
      <path
        fill={fill || '#7E8A96'}
        fillRule="evenodd"
        d="M5.79417 16.5183C2.19424 13.0909 2.05438 7.39409 5.48178 3.79417C8.90918 0.194243 14.6059 0.0543832 18.2059 3.48178C21.8058 6.90918 21.9457 12.6059 18.5183 16.2059L12.3124 22.7241L5.79417 16.5183ZM17.0698 14.8268L12.243 19.8965L7.17324 15.0698C4.3733 12.404 4.26452 7.97318 6.93028 5.17324C9.59603 2.3733 14.0268 2.26452 16.8268 4.93028C19.6267 7.59603 19.7355 12.0268 17.0698 14.8268ZM12 9C13.1046 9 14 8.10457 14 7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7C10 8.10457 10.8954 9 12 9ZM8 12.7745C8.33333 11.8496 9.6 10 12 10C13 10 15.2 10.5549 16 12.7745C14.6667 13.6993 11.2 14.994 8 12.7745Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default MeetingPointIcon;
